import { useUserProfileViewerQuery } from '@containers/UserProfile/graphql.v3.generated';
import { ProfileTabs } from '@components/ProfileTabs';

import { useProfileTabsQueryQuery } from './gql/graphql.v3.generated';
import { useProfileTabsPostsQuery } from './gql/graphql.v5.generated';


type ProfileContainerProps = {
  username: string;
  className?: string;
};

export const ProfileTabsContainer: React.FC<ProfileContainerProps> = ({
  username,
  className,
}) => {
  const { data } = useProfileTabsQueryQuery({
    variables: { username },
    context: { batch: true },
  });

  const { data: postsData } = useProfileTabsPostsQuery({
    variables: { username },
    context: {
      v5: true,
      batch: true,
    },
  });

  const { data: viewerData } = useUserProfileViewerQuery({
    context: { batch: true, ignoreAuthError: true },
  });

  const viewer = viewerData?.viewer;
  const userProfile = data?.user;
  const isViewerAuthenticated = !!viewer && !!viewer.id;
  const isViewerProfile = viewer?.id === userProfile?.id;
  const isCanWriteMessage = isViewerAuthenticated && !isViewerProfile && !!viewer?.isAdmin;
  const isCanComplain = isViewerAuthenticated && !isViewerProfile;

  if (!userProfile) {
    return null;
  }

  return (
    <ProfileTabs
      className={className}
      username={username}
      positiveReviews={userProfile.positiveReviews}
      negativeReviews={userProfile.negativeReviews}
      productsCount={userProfile.productsCount || 0}
      postsCount={postsData?.user?.postsAmount || 0}
      isCanComplain={isCanComplain}
      isCanWriteMessage={isCanWriteMessage}
    />
  );
};
